var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`pill-button ${_vm.className}`,on:{"click":function($event){return _vm.$emit('onClick')}}},[(_vm.startIcon)?_c(_vm.startIcon,{tag:"component"}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n  "),(_vm.endIcon)?_c(_vm.endIcon,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }